export var FontDecorationToken;
(function (FontDecorationToken) {
    FontDecorationToken["none"] = "none";
    FontDecorationToken["underline"] = "underline";
    FontDecorationToken["lineThrough"] = "line-through";
})(FontDecorationToken || (FontDecorationToken = {}));
export var FontTransformToken;
(function (FontTransformToken) {
    FontTransformToken["none"] = "none";
    FontTransformToken["uppercase"] = "uppercase";
    FontTransformToken["lowercase"] = "lowercase";
    FontTransformToken["capitalize"] = "capitalize";
})(FontTransformToken || (FontTransformToken = {}));
export var FontSizeTokens;
(function (FontSizeTokens) {
    FontSizeTokens["SIZE_8"] = "SIZE_8";
    FontSizeTokens["XXS"] = "XXS";
    FontSizeTokens["XS"] = "XS";
    FontSizeTokens["SM"] = "SM";
    FontSizeTokens["MD"] = "MD";
    FontSizeTokens["LG"] = "LG";
    FontSizeTokens["XL"] = "XL";
    FontSizeTokens["XXL"] = "XXL";
    FontSizeTokens["XXXL"] = "XXXL";
    FontSizeTokens["XXXXL"] = "XXXXl";
    FontSizeTokens["XXXXXL"] = "XXXXXl";
    FontSizeTokens["XXXXXXL"] = "XXXXXXl";
    FontSizeTokens["XXXXXXXL"] = "XXXXXXXl";
})(FontSizeTokens || (FontSizeTokens = {}));
export var TypographyTypeDLS;
(function (TypographyTypeDLS) {
    TypographyTypeDLS["H1R"] = "H1R";
    TypographyTypeDLS["H1S"] = "H1S";
    TypographyTypeDLS["H1B"] = "H1B";
    TypographyTypeDLS["H2R"] = "H2R";
    TypographyTypeDLS["H2S"] = "H2S";
    TypographyTypeDLS["H2B"] = "H2B";
    TypographyTypeDLS["H3R"] = "H3R";
    TypographyTypeDLS["H3S"] = "H3S";
    TypographyTypeDLS["H3B"] = "H3B";
    TypographyTypeDLS["H4R"] = "H4R";
    TypographyTypeDLS["H4S"] = "H4S";
    TypographyTypeDLS["H4B"] = "H4B";
    TypographyTypeDLS["H5S"] = "H5S";
    TypographyTypeDLS["B0R"] = "B0R";
    TypographyTypeDLS["B0M"] = "B0M";
    TypographyTypeDLS["B0S"] = "B0S";
    TypographyTypeDLS["B0B"] = "B0B";
    TypographyTypeDLS["B1R"] = "B1R";
    TypographyTypeDLS["B1M"] = "B1M";
    TypographyTypeDLS["B1S"] = "B1S";
    TypographyTypeDLS["B1B"] = "B1B";
    TypographyTypeDLS["B2R"] = "B2R";
    TypographyTypeDLS["B2M"] = "B2M";
    TypographyTypeDLS["B2S"] = "B2S";
    TypographyTypeDLS["B2B"] = "B2B";
    TypographyTypeDLS["B3R"] = "B3R";
    TypographyTypeDLS["B3M"] = "B3M";
    TypographyTypeDLS["B3S"] = "B3S";
    TypographyTypeDLS["B3B"] = "B3B";
})(TypographyTypeDLS || (TypographyTypeDLS = {}));
export var FontFamilyTokens;
(function (FontFamilyTokens) {
    FontFamilyTokens["Inter"] = "Inter";
    FontFamilyTokens["Poppins"] = "Poppins";
})(FontFamilyTokens || (FontFamilyTokens = {}));
export var EllipsizeModeTokens;
(function (EllipsizeModeTokens) {
    EllipsizeModeTokens["head"] = "head";
    EllipsizeModeTokens["middle"] = "middle";
    EllipsizeModeTokens["tail"] = "tail";
    EllipsizeModeTokens["clip"] = "clip";
})(EllipsizeModeTokens || (EllipsizeModeTokens = {}));
export var TextAlignTokens;
(function (TextAlignTokens) {
    TextAlignTokens["auto"] = "auto";
    TextAlignTokens["left"] = "left";
    TextAlignTokens["right"] = "right";
    TextAlignTokens["center"] = "center";
    TextAlignTokens["justify"] = "justify";
})(TextAlignTokens || (TextAlignTokens = {}));
export var TypographyTypeTokens;
(function (TypographyTypeTokens) {
    /**
     * @description Default text color,Manrope-Regular,14px
     */
    TypographyTypeTokens["DEFAULT"] = "DEFAULT";
    /**
     * @description Title,Manrope-Bold,12px
     */
    TypographyTypeTokens["H7"] = "H7";
    TypographyTypeTokens["H6"] = "H6";
    TypographyTypeTokens["H5"] = "H5";
    TypographyTypeTokens["H4"] = "H4";
    TypographyTypeTokens["H3"] = "H3";
    TypographyTypeTokens["H2"] = "H2";
    TypographyTypeTokens["H1"] = "H1";
    TypographyTypeTokens["P5"] = "P5";
    TypographyTypeTokens["B7"] = "B7";
    TypographyTypeTokens["B6"] = "B6";
    TypographyTypeTokens["B5"] = "B5";
    TypographyTypeTokens["B4"] = "B4";
    TypographyTypeTokens["B3"] = "B3";
    TypographyTypeTokens["S1"] = "S1";
    TypographyTypeTokens["S2"] = "S2";
    TypographyTypeTokens["S3"] = "S3";
    TypographyTypeTokens["S4"] = "S4";
    TypographyTypeTokens["S5"] = "S5";
    TypographyTypeTokens["S6"] = "S6";
    TypographyTypeTokens["S7"] = "S7";
    /**
     * @deprecated
     */
    TypographyTypeTokens["primary"] = "primary";
    /**
     * @deprecated
     */
    TypographyTypeTokens["secondary"] = "secondary";
    /**
     * @deprecated
     */
    TypographyTypeTokens["placeholder"] = "placeholder";
})(TypographyTypeTokens || (TypographyTypeTokens = {}));
